import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  icon: {
    display: 'flex',
    color: theme.palette.grey[500],
    width: '20px',
  },
}));

export default useStyles;
